module.exports = __webpack_public_path__ + "img/bg-1111.481bd95a.png";